import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerContract } from "../_types/worker-contract";

@Injectable({
  providedIn: 'root',
})
export class WorkerContractsService extends Service<WorkerContract> {
  public override type = 'workerContracts';
  public override url = 'providers/workerContracts';
}
